/**************************************************
 * Nombre:       Formulario_Producto_Variante
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {useIngresarObjeto} from "../../../Modulo_formularios/Hooks/useIngresarObjeto";
import Formulario_Producto_Variante_Ingreso from "./Formulario_Producto_Variante_Ingreso";
import Tarjetas_Producto from "../../Tarjeta/Tarjetas_Producto";
import Tarjetas_Producto_Variante from "../../Tarjeta/Tarjetas_Producto_Variante";

const Formulario_Producto_Variante = ({...props}) => {
    const {IngresarObjeto} = useIngresarObjeto({
        props: props,
        nombre: 'Guardar Variante',
        dato: 'variantes',
        Tarjeta: Tarjetas_Producto_Variante,
        Formulario: Formulario_Producto_Variante_Ingreso
    })

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={12}>
                    <IngresarObjeto/>
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Producto_Variante